export default [
  "rgb(58, 113, 194)",
  "rgb(203, 83, 51)",
  "rgb(85, 178, 197)",
  "rgb(128, 201, 71)",
  "rgb(237, 187, 102)",
  "rgb(190, 171, 238)",
];
